import { Injectable } from "@angular/core";
import { JobPriority } from "./jobs-and-billing-priority.interface";

@Injectable({ providedIn: "root" })
export class JobsAndBillingPriorityService {
    readonly jobPriorityI18nKeys: Record<string, string> = {
        null: "JobsAndBilling.Priorities.Normal",
        [JobPriority.Red]: "JobsAndBilling.Priorities.Red",
        [JobPriority.Blue]: "JobsAndBilling.Priorities.Blue",
        [JobPriority.Green]: "JobsAndBilling.Priorities.Green",
    };

    readonly jobPriorityOptions = Object.values(JobPriority).map((value) => ({
        value: value,
        label: this.jobPriorityI18nKeys[String(value)],
    }));
}
